export default function() {
    let navbar = document.querySelector('#page-headerNavbarContent');
    let navToggle = document.querySelector('.nav-toggler');    
    
    navToggle.addEventListener('click', () =>{                
        if(navbar.classList.contains('show')){            
            navbar.classList.remove('show');         
            navToggle.classList.remove('show');             
        }
        else{            
            navbar.classList.add('show');
            navToggle.classList.add('show');     
        }
    });
    
    navbar.addEventListener('click', () =>{                
        if(navbar.classList.contains('show')){            
            navbar.classList.remove('show');         
            navToggle.classList.remove('show');             
        }
    });
}
